import React, { useMemo, useState } from 'react';

const matchesSearch = (thumb, query) => {
  if (!query) return true;
  const haystack = `${thumb.title || ''} ${thumb.author || ''}`.toLowerCase();
  return haystack.includes(query);
};

const BookThumbnailPicker = ({
  thumbs,
  loading,
  selectedImage,
  onSelect,
  listClassName = 'max-h-72',
}) => {
  const [search, setSearch] = useState('');
  const query = search.trim().toLowerCase();
  const filtered = useMemo(
    () => thumbs.filter((thumb) => matchesSearch(thumb, query)),
    [thumbs, query]
  );

  if (loading) {
    return <p className="text-sm text-slate-500">Loading book thumbnails...</p>;
  }

  if (thumbs.length === 0) {
    return <p className="text-sm text-slate-500">No book thumbnails found.</p>;
  }

  return (
    <div className="space-y-2">
      <input
        type="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.preventDefault();
        }}
        placeholder="Search books..."
        className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm text-slate-800"
      />
      <div className={`${listClassName} overflow-y-auto rounded-xl border border-slate-200 bg-white divide-y divide-slate-100`}>
        {filtered.length === 0 ? (
          <p className="px-4 py-6 text-center text-sm text-slate-500">
            No books found matching your search
          </p>
        ) : (
          filtered.map((bookThumb) => {
            const selected = selectedImage === bookThumb.image;
            return (
              <button
                key={bookThumb.id}
                type="button"
                onClick={() => onSelect(bookThumb)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 text-left transition-colors ${
                  selected ? 'bg-pink-50' : 'hover:bg-slate-50'
                }`}
              >
                <img
                  src={bookThumb.image}
                  alt=""
                  className={`w-16 h-10 flex-shrink-0 rounded object-cover bg-slate-100 border-2 ${
                    selected ? 'border-pink-500' : 'border-slate-200'
                  }`}
                  onError={(e) => {
                    e.currentTarget.style.visibility = 'hidden';
                  }}
                />
                <div className="min-w-0 flex-1">
                  <p className={`truncate text-sm ${selected ? 'font-semibold text-slate-900' : 'font-medium text-slate-800'}`}>
                    {bookThumb.title}
                  </p>
                  {bookThumb.author && (
                    <p className="truncate text-xs text-slate-500">{bookThumb.author}</p>
                  )}
                </div>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default BookThumbnailPicker;
